// extracted by mini-css-extract-plugin
export default {"container":"FlSearchBox_container__No6Fd","input":"FlSearchBox_input__V97L4"};